import moment from 'moment-mini'
import { Role } from '../role'
import { Product } from '../../product/product'

export class RolePermission {
  id: number
  roleId: number
  price: number
  validFrom?: moment.Moment
  validTill?: moment.Moment
  productId: number
  courseId: number
  subscriptionId: number
  allowAllProducts: boolean
  allowAllSubscriptions: boolean
  product?: Product
  // join
  role: Role
}
